module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABBY GREEN")])]), _vm._v(" got hooked on Harlequin"), _c('sup', [_vm._v("®")]), _vm._v(" romances while still in her teens, when she stumbled across one belonging to her grandmother in the west of Ireland. After many years of reading them voraciously, she sat down one day and gave it a go herself. Happily, after a few failed attempts, Mills & Boon bought her first manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Abby works freelance in the film and TV industry, but thankfully the four a.m. starts and the stresses of dealing with recalcitrant actors are becoming more and more infrequent, leaving her more time to write!")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("She loves to hear from readers, and you can contact her through her website at www.abby-green.com. She lives and works in Dublin.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Recent titles by the same author:")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("THE SULTAN’S CHOICE"), _c('br'), _vm._v("SECRETS OF THE OASIS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06d075c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781460346396_epub_ata_r1.vue
// module id = 60
// module chunks = 0